import type { AppRouteRecordRaw, AppRouteModule } from '/@/router/types'

import {
  PAGE_NOT_FOUND_ROUTE,
  REDIRECT_ROUTE,
  NOAUTH_ROUTE,
  PERMISSION_EXCEPTION,
  LOGIN_ROUTE,
} from '/@/router/routes/basic'

const modules = import.meta.globEager('./modules/**/*.ts')

const routeModuleList: AppRouteModule[] = []

Object.keys(modules).forEach((key) => {
  const mod = (modules[key] as any).default || {}
  const modList = Array.isArray(mod) ? [...mod] : [mod]
  routeModuleList.push(...modList)
})

export const asyncRoutes = [PAGE_NOT_FOUND_ROUTE, ...routeModuleList]

export const RootRoute: AppRouteRecordRaw = {
  path: '/',
  name: 'Root',
  // redirect: PageEnum.BASE_HOME,
  meta: {
    title: 'Root',
  },
}

// Basic routing without permission
export const basicRoutes = [LOGIN_ROUTE, REDIRECT_ROUTE, NOAUTH_ROUTE, PERMISSION_EXCEPTION]
